function e(e=``){return e.toLowerCase().trim().replace(/"/g,``).replace(/'/g,``)}export{e as cleanFont};
//# sourceMappingURL=clean-font.js.map